import { Component } from '@angular/core';

@Component({
  selector: 'app-shop-custom',
  templateUrl: './shop-custom.html',
  styleUrl: './shop-custom.css',
})
export class ShopCustom {}
